<!--
 * @Description: 
 * @Author: dezhi
 * @Date: 2020-02-19 15:46:56
 * @LastEditTime: 2020-05-26 16:23:53
 * @LastEditors: zhaoshuai
 -->
<template>
  <div class="wrapper step-box flex sharing-h">
    <span class="exam-info">2021年税务管理师CTM（初级）考试报名</span>
    <span class="apply-step">
      步骤
      <b>{{step}}</b>/6  {{stepName}}
    </span>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Step",
  components: {},
  data() {
    return {
      step: "",
      stepName: ""
    };
  },
  mounted() {
    if (this.$route.path == "/authent") {
      this.step = 1;
      this.stepName="实名认证"
    } else if (this.$route.path == "/profile") {
      this.step = 2;
      this.stepName="身份资料"
    } else if (this.$route.path == "/area") {
      this.step = 3;
      this.stepName="选择考区"
    } else if (this.$route.path == "/photo") {
      this.step = 4;
      this.stepName="报名照片"
    } else if (this.$route.path == "/phone") {
      this.step = 5;
      this.stepName="验证手机号"
    } else if (this.$route.path == "/infomation") {
      this.step = 6;
      this.stepName="确认信息"
    }
  }
};
</script>

<style>
.step-box {
  margin-top: 15px;
  background: rgba(249, 249, 249, 1);
}
span b {
  color: brown;
}
</style>